import React from "react";
import "../styles/PopUpStyles.css"; // Import styles

interface OverlayPopupProps {
  title: string;
  body: string;
  button1Text: string;
  button2Text: string;
  button1CallBack: () => void;
  button2CallBack: () => void;
}

const OverlayErrorPoppup: React.FC<OverlayPopupProps> = ({
  title,
  body,
  button1Text,
  button2Text,
  button1CallBack,
  button2CallBack,
}) => {
  return (
    <div className="popup-overlay">
      <div className="popup-container-error-childwindow">
        <div className="popup-header">
          <h2>{title}</h2>
        </div>
        <div className="popup-body">
          <p>{body}</p>
        </div>
        <div className="popup-footer">
          <button onClick={button1CallBack} className="popup-button">
            {button1Text}
          </button>
          <div style={{ paddingRight: "20px" }}></div>
          <button onClick={button2CallBack} className="popup-button-success">
            {button2Text}
          </button>
        </div>
      </div>
    </div>
  );
};

interface OverlaySingleErrorPoppupProps {
  title: string;
  body: string;
  button1Text: string;
  button1CallBack: () => void;
}

const OverlaySingleErrorPoppup: React.FC<OverlaySingleErrorPoppupProps> = ({
  title,
  body,
  button1Text,
  button1CallBack,
}) => {
  return (
    <div className="popup-overlay">
      <div className="popup-container-error-childwindow">
        <div className="popup-header">
          <h2>{title}</h2>
        </div>
        <div className="popup-body">
          <p>{body}</p>
        </div>
        <div className="popup-footer">
          <button onClick={button1CallBack} className="popup-button">
            {button1Text}
          </button>
        </div>
      </div>
    </div>
  );
};

export { OverlaySingleErrorPoppup, OverlayErrorPoppup };
